<template>
    <div class="upload_images" :class="{
        'one': fileMax == 1
    }">
        <template v-if="fileMax == 1">
            <div class="img_box">
                <div class="img" v-if="images[0]">
                    <img :src="images[0].url" @click="lookImage(images[0].url)">
                    <div class="state" v-show="images[0].loading" v-loading="images[0].loading"
                        element-loading-text="图片正在上传"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"></div>
                </div>
                <div class="add" @click="uploadImage('images')" v-show="fileMax == 1 || images.length < fileMax">
                    <i class="el-icon-plus"></i>
                </div>
            </div>
            <div class="upload_tip">
                <slot name="tip"></slot>
            </div>
        </template>
        <template v-else>
            <el-tree
                class="horizontal-tree"
                :data="images"
                node-key="url"
                draggable
                empty-text=""
                :allow-drop="handleAllowDrop" 
                @node-drop="handleNodeDrop"
            >
                <div class="img" slot-scope="scope" @click="lookImage(scope.data.url)">
                    <img :src="scope.data.url">
                    <div class="state" v-loading="scope.data.loading"
                        element-loading-text="图片正在上传"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"></div>
                    <div class="delete" @click.stop="deleteImages(scope.data.url)"><i class="el-icon-circle-close"></i></div>
                </div>
            </el-tree>
            <div class="img_box">
                <div class="add" @click="uploadImage('images')" v-show="fileMax == 1 || images.length < fileMax">
                    <i class="el-icon-plus"></i>
                </div>
                <div class="upload_tip">
                    <slot name="tip"></slot>
                </div>
            </div>
        </template>
        <el-image ref="imagePreview" class="image_preview"
            :src="imageUrl" 
            :preview-src-list="imagePreviews">
        </el-image>
    </div>
</template>

<script>
import {
    formatFileSize
} from '@/common/tools';
import file from '@/common/file';
export default {
    name: 'Images',
    props: {
        value: [Array, String],
        fileMax: {
            type: Number,
            default: 1
        },
        fileType: {
            type: Array,
            default: ()=>['jpg','jpeg','png']
        },
        fileSize: {
            type: Number,
            default: 1*1024*1024
        },
        uploaderOptions: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
            images: [],
            imageUrl: ''
        }
    },
    computed: {
        imagePreviews(){
            return this.images.map(item=>item.url);
        },
        accept(){
            return this.fileType.map(type=>('.' + type)).join(',');
        },
    },
    watch: {
        value:{
            immediate: true,
            handler(newValue){
                if(newValue){
                    if(this.fileMax == 1){
                        this.images = [{
                            url: newValue,
                            loading: false
                        }]
                    }else{
                        this.images = newValue.map(item=>({...item}));
                    }
                }else{
                    this.images = [];
                }
            }
        }
    },
    methods: {
        handleAllowDrop(_, __, type){
            if(type == 'inner') return false;
            return true;
        },
        handleNodeDrop(draggingNode, dropNode){
            let arr = [...this.images];
            let dragData = draggingNode.data,
                dropData = dropNode.data;
            let dragItem = arr.splice(dragData.index, 1)[0];
            arr.splice(dropData.index, 0, dragItem);
            this.images = arr;
            this.change();
        },
        change(){
            if(this.fileMax == 1){
                let image = this.images[0];
                if(image){
                    this.$emit('input', image.url);
                    this.$emit('change', image);
                }else{
                    this.$emit('input', '');
                    this.$emit('change', undefined);
                }
            }else {
                let images = this.images.map(item=>({...item}));
                this.$emit('input', images);
                this.$emit('change', images);
            }
        },
        uploadImage(){
            file.cloose({
                accept: this.accept
            }).then(fileData=>{
                let name = fileData.name;
                let fileType = name.substr(name.lastIndexOf('.') + 1).toLowerCase()
                if(!this.fileType.includes(fileType)){
                    this.$message.error('不支持此文件类型');
                    return;
                }
                if(fileData.size > this.fileSize) {
                    this.$message.error(`图片大小不能超过 ${formatFileSize(this.fileSize)}，请压缩后上传`);
                    return;
                }
                let imgSrc = URL.createObjectURL(fileData);
                if(this.fileMax == 1){
                    this.images = [{
                        url: imgSrc,
                        loading: true,
                        size: fileData.size,
                        name
                    }]
                }else{
                    this.images.push({
                        url: imgSrc,
                        loading: true,
                        size: fileData.size,
                        name
                    })
                    this.change();
                }
                file.ossUpload({
                    file: fileData,
                    type: fileType,
                    uploadOptions: this.uploaderOptions
                }).then(data=> {
                    let index = this.images.findIndex(item=>item.url === imgSrc);
                    if(index >= 0){
                        let old = this.images[index];
                        this.$set(this.images, index, {
                            ...old,
                            url: data.url,
                            loading: false
                        });
                        this.change();
                    }
                }).catch(()=>{
                    let index = this.images.findIndex(item=>item.url === imgSrc);
                    if(index >= 0){
                        this.images.splice(index, 1);
                        this.change();
                    }
                    this.$message.error('图片上传失败，请重试！');
                });
            })
        },
        lookImage(url){
            if(!url) return;
            this.imageUrl = url;
            this.$refs.imagePreview.showViewer = true;
        },
        deleteImages(url){
            let index = this.images.findIndex(item=>item.url === url);
            this.images.splice(index, 1);
            this.change();
        },
    }
}
</script>

<style scoped>
.upload_images{
    max-width: 700px;
}
.upload_images .img_box{
    display: flex;
    flex-wrap: wrap;
}
.upload_images .img{
    width: 100px;
    height: 100px;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
}
.upload_images .img img{
    display: block;
    height: 100%;
    width: 100%;
    object-fit: contain;
}
.upload_images .img .state{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.upload_images .img .delete{
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    display: flex;

    font-size: 20px;
    color: red;
}
.upload_images .add{
    flex: none;
    width: 100px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
}
.upload_images .add:hover {
    border-color: #409EFF;
}
.upload_images .add i{
    flex: none;
    width: 100px;
    height: 100px;
    font-size: 28px;
    color: #8c939d;
    line-height: 100px;
    text-align: center;
}
.upload_images .upload_tip{
    flex: none;
    margin-top: 10px;
    margin-left: 10px;

    font-size: 12px;
    color: #606266;
    line-height: 2em;
}
/* 水平 Tree 核心样式 */
.upload_images .el-tree.horizontal-tree {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
}
.upload_images .el-tree.horizontal-tree::v-deep .el-tree-node__expand-icon{
    width: 0;
    height: 0;
    padding: 0;
}
.upload_images .el-tree.horizontal-tree::v-deep .el-tree__drop-indicator{
    width: 1px;
    height: 100px;
}
.upload_images.one .img{
    flex: none;
    width: auto;
    min-width: 100px;
    height: 100px;
    margin-right: 10px;
    padding: 0;
}
.upload_images.one .upload_tip{
    margin-top: 7px;
    margin-left: 0;
}
.el-image{
    display: none !important;
}
</style>